export default "__VITE_ASSET__BPEgMMvq__"